import React, { Component } from "react";
import "./FooterTools.css";
import * as helpers from "../helpers/helpers";

const feedbackTemplate = (url, xmin, xmax, ymin, ymax, centerx, centery, scale) => `${url}/?xmin=${xmin}&xmax=${xmax}&ymin=${ymin}&ymax=${ymax}&centerx=${centerx}&centery=${centery}&scale=${scale}`;

class FooterTools extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scale: "",
      basemapType: "IMAGERY",
      scaleBarTextClassname: "slidein",
      display: "block",
      customScale: "",
      currentScale: "",
      isCustomScaleSelected: false, // Added to manage custom scale input visibility
    };

    this.mapScales = [
      { label: "1:250", value: 250 },
      { label: "1:500", value: 500 },
      { label: "1:1 000", value: 1000 },
      { label: "1:2 000", value: 2000 },
      { label: "1:5 000", value: 5000 },
      { label: "1:10 000", value: 10000 },
      { label: "1:25 000", value: 25000 },
      { label: "1:50 000", value: 50000 },
      { label: "1:100 000", value: 100000 },
      { label: "1:200 000", value: 200000 },
      { label: "1:500 000", value: 500000 },
      { label: "1:750 000", value: 750000 },
      { label: "1:1 000 000", value: 1000000 },
    ];

    window.emitter.addListener("printActive", (print) => this.setState({ display: print }));

    window.emitter.addListener("basemapChanged", (type) => {
      this.setState({ basemapType: type });
    });

    window.emitter.addListener("mapControlsChanged", (control, visible) => this.controlStateChange(control, visible));
  }

  componentDidMount() {
    helpers.waitForLoad("map", Date.now(), 30, () => this.onMapLoad());

    this.setState({ showScale: window.mapControls.scale });
  }

  onMapLoad() {
    const initScale = helpers.getMapScale();

    this.setState({
      scale: initScale.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "),
    });

    window.map.on("moveend", () => {
      const scale = helpers.getMapScale();

      this.setState({
        scale: scale.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "),
      });
    });
  }

  onPrintClick = () => {
    helpers.addAppStat("Print", "Click (Footer)");
  };

  onLegendClick = () => {
    helpers.addAppStat("Legenda", "Click (Footer)");
  };

  onFeedbackClick = () => {
    helpers.waitForLoad("settings", Date.now(), 30, () => {
      helpers.addAppStat("Feedback", "Click (Footer)");

      const scale = helpers.getMapScale();
      const extent = window.map.getView().calculateExtent(window.map.getSize());
      const xmin = extent[0];
      const xmax = extent[1];
      const ymin = extent[2];
      const ymax = extent[3];
      const center = window.map.getView().getCenter();

      let feedbackUrl = feedbackTemplate(window.config.feedbackUrl, xmin, xmax, ymin, ymax, center[0], center[1], scale);
      if (window.config.mapId !== null && window.config.mapId !== undefined && window.config.mapId.trim() !== "") feedbackUrl += "&MAP_ID=" + window.config.mapId;

      helpers.showURLWindow(feedbackUrl, false, "full");
    });
  };

  onTermsClick = () => {
    helpers.waitForLoad("settings", Date.now(), 30, () => {
      helpers.showURLWindow(window.config.termsUrl, false, "full");
      helpers.addAppStat("Terms", "Click (Footer)");
    });
  };

  onScaleClick = (value) => {
    if (value === "custom") {
      this.setState({ currentScale: "custom", isCustomScaleSelected: true });
    } else {
      this.setState({ currentScale: value, isCustomScaleSelected: false });
      helpers.setMapScale(value);
    }
  };

  handleCustomScaleChange = (event) => {
    const value = event.target.value.replace(/\s/g, "");
    this.setState({ customScale: value });
    if (!isNaN(value) && value !== "") {
      helpers.setMapScale(parseInt(value, 10));
    }
  };

  resetScale = () => {
    this.setState({ customScale: "", currentScale: "", isCustomScaleSelected: false });
    const defaultScale = helpers.getMapScale();
    this.setState({ scale: defaultScale.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") });
    helpers.setMapScale(defaultScale);
  };

  controlStateChange(control, state) {
    switch (control) {
      case "scale":
        this.setState({ showScale: state });
        break;
      default:
        break;
    }
  }

  render() {
    setTimeout(() => {
      const col = document.getElementsByClassName("ol-scale-line-inner");
      if (col.length > 0) {
        const olScaleBar = col[0];
        let scScaleBar = document.getElementById("sc-scale-bar-text");
        scScaleBar.style.cssText = "width: " + olScaleBar.style.width + "; display: flex; align-items: center; background: transparent;";
      }
    }, 10);

    return (
      <div className="map-theme">
        <div id="sc-scale-bar-text" className={"sc-map-footer-scale-only selector ol-scale-line"} style={{ display: this.state.display }}>
          {!this.state.isCustomScaleSelected && (
            <select
              id="sc-scale-bar-select"
              onChange={(evt) => {
                this.onScaleClick(evt.target.value);
              }}
              value={this.state.currentScale}
            >
              <option key={helpers.getUID()} value="">
                {"1 : " + this.state.scale}
              </option>
              {this.mapScales.map((item) => (
                <option key={helpers.getUID()} value={item.value}>
                  {item.label}
                </option>
              ))}
              <option key={helpers.getUID()} value="custom">
                Vlastná mierka
              </option>
            </select>
          )}
          {this.state.isCustomScaleSelected && (
             <div style={{ position: 'relative', display: 'flex', alignItems: 'center', zIndex: "99999" }}>
              <input
                type="text"
                value={this.state.customScale}
                onChange={this.handleCustomScaleChange}
                placeholder="Zadajte vlastnú mierku 1:"
                className="custom-scale-input"
              />
              <button onClick={this.resetScale} style={{
                display: "block",
                color: "white",
                border: "none",
                marginBottom: "-1px",
                background: "#00000052",
                cursor: "pointer",
              }}>x</button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default FooterTools;
